export type WsMessage = string | ArrayBuffer | Blob | ArrayBufferView

export class WsEvent {
  public target: unknown
  public type: string
  constructor(type: string, target: unknown) {
    this.target = target
    this.type = type
  }
}

export class WsErrorEvent extends WsEvent {
  public message: string
  public error: Error
  constructor(error: Error, target: unknown) {
    super('error', target)
    this.message = error.message
    this.error = error
  }
}

export class WsCloseEvent extends WsEvent {
  public code: number
  public reason: string
  public wasClean = true
  constructor(code = 1000, reason = '', target: unknown) {
    super('close', target)
    this.code = code
    this.reason = reason
  }
}

export class WsMessageEvent<T = unknown> extends MessageEvent<T> {}

export interface WsEventMap {
  close: WsCloseEvent
  error: WsErrorEvent
  message: WsMessageEvent
  open: WsEvent
}

export interface WsEventListenerObject<T extends WsEvent> {
  handleEvent: (event: T) => void
}

export interface WsEventListenerObjectMap {
  close: WsEventListenerObject<WsCloseEvent>
  open: WsEventListenerObject<WsEvent>
  error: WsEventListenerObject<WsErrorEvent>
  message: WsEventListenerObject<WsMessageEvent>
}

export interface WsEventListenerMap {
  close: (
    event: WsCloseEvent,
  ) => Promise<void> | WsEventListenerObject<WsCloseEvent>
  error: (
    event: WsErrorEvent,
  ) => Promise<void> | WsEventListenerObject<WsErrorEvent>
  message: (
    event: WsMessageEvent,
  ) => Promise<void> | WsEventListenerObject<WsMessageEvent>
  open: (event: WsEvent) => Promise<void> | WsEventListenerObject<WsEvent>
}

export type WsHandlerListenerMap = {
  close: WsEventListenerMap['close'][]
  error: WsEventListenerMap['error'][]
  message: WsEventListenerMap['message'][]
  open: WsEventListenerMap['open'][]
}

export interface WsHandlerOptions {
  reconnectionTimeout: number
  timeoutInterval: number
  maxreconnectionTimeout: number
  maxRetries: number
  reconnectionTimeoutDecay: number
  maxReconnectionDelay: number
  minReconnectionDelay: number
  maxEnqueuedMessages: number
  minUptime: number
}
